<template>
  <v-container v-if="getCustomer" class="pa-0" grid-list-lg fluid>

    <Edit v-if="getCustomer" :editDialog="editDialog" @close="editDialog = false" @submit="loadData"
      :editCustomer="getCustomer"></Edit>

    <ParentInvoiceCreate :createDialog="createParentInvoiceDialog" @close="createParentInvoiceDialog = false"
      @submit="invoiceCreated" :parent="getCustomer"></ParentInvoiceCreate>
    <!-- @close="assignClose"
      @submit="getList" -->

    <v-card tile v-if="getCustomer">
      <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon @click="back()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title class="text-capitalize">
          {{ getCustomer.name }}
        </v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-app-bar-nav-icon @click="moveBack(getCustomer.id)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>
        <span>{{ getCustomer.localId }}</span>
        <v-app-bar-nav-icon @click="moveNext(getCustomer.id)">
          <v-icon>mdi-chevron-right</v-icon>
        </v-app-bar-nav-icon>
        <v-menu bottom left offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon>
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list class="menu-button">
            <div v-if="checkRightStatus(6)">
              <v-list-item v-if="$vuetify.breakpoint.xsOnly" @click="newInvoice">
                <v-list-item-title>New Invoice</v-list-item-title>
              </v-list-item>
            </div>
            <v-list-item @click="editDialog = true">
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>

            <!-- <DeleteCustomer :Customer="getCustomer" @submit="$router.go(-1)" /> -->
            <v-list-item @click="viewOpenInvoice()">
              <v-list-item-title>View Open Invoice</v-list-item-title>
            </v-list-item>
            <v-list-item @click="viewBalanceLetter()">
              <v-list-item-title>View Pending Bal Letter</v-list-item-title>
            </v-list-item>
            <SyncBalance />
            <Statement :CustomerId="getCustomer.id" />
            <v-divider></v-divider>
            <PaymentCollectLink :id="getCustomer.id" :customer="getCustomer" />

            <!-- <SearilSearch /> -->
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-divider></v-divider>
      <v-alert v-if="getCustomer" border="left" type="error" tile transition="slide-y-transition" class="mb-2"
        v-model="getCustomer.alert" color="red">
        <strong>{{ getCustomer.note }}</strong>
      </v-alert>
      <v-card-text>
        <v-layout class="mt-5" v-if="!getCustomer" align-center justify-center column fill-height>
          <v-progress-circular size="70" width="7" color="purple" indeterminate="indeterminate"></v-progress-circular>
          <div>Loading...</div>
        </v-layout>
        <v-layout row wrap v-else justify-space-between>
          <v-flex shrink>
            <v-layout row v-if="getCustomer.fatherName">
              <v-flex shrink>
                <v-img width="50" src="@/assets/islamic.png"></v-img>
              </v-flex>
              <v-flex shrink>
                <div class="text-capitalize" v-if="getCustomer.fatherName">
                  {{ getCustomer.fatherName }}
                </div>
                <div class="text-capitalize" v-if="getCustomer.fatherPhoneNumber">
                  <a :href="`tel:${getCustomer.fatherPhoneNumber}`">{{ getCustomer.fatherPhoneNumber | USPhoneNumber
                    }}</a>
                </div>
                <div class="text-lowercase" v-if="getCustomer.fatherEmailAddress">
                  {{ getCustomer.fatherEmailAddress }}
                </div>
              </v-flex>
            </v-layout>
            <v-layout row v-if="getCustomer.motherName">
              <v-flex shrink>
                <v-img width="50" src="@/assets/moroccan.png"></v-img>
              </v-flex>
              <v-flex shrink>
                <div class="text-capitalize" v-if="getCustomer.motherName">
                  {{ getCustomer.motherName }}
                </div>
                <div class="text-capitalize" v-if="getCustomer.motherPhoneNumber">
                  <a :href="`tel:${getCustomer.motherPhoneNumber}`">{{ getCustomer.motherPhoneNumber | USPhoneNumber
                    }}</a>
                </div>
                <div class="text-lowercase" v-if="getCustomer.motherEmailAddress">
                  {{ getCustomer.motherEmailAddress }}
                </div>
              </v-flex>
            </v-layout>


            <span v-if="!$vuetify.breakpoint.xsOnly">
              <v-btn class="mt-2" color="primary" @click="createParentInvoiceDialog = !createParentInvoiceDialog">Quick
                Fee Invoice</v-btn>
            </span>
            <div class="mt-2" v-if="getCustomer.MerchantCustomers.length">
              <v-chip label color="yellow" text-color="black">
                <v-avatar left>
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                </v-avatar>
                Online
              </v-chip>

            </div>

            <div class="mt-2" v-if="getCustomer.stripeId">
              <a style="text-decoration: none;" :href="`https://dashboard.stripe.com/customers/${getCustomer.stripeId}`"
                target="_blank">
                <v-chip label color="blue" text-color="white" close @click:close="clearStripe">
                  <v-avatar left>
                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                  </v-avatar>
                  Stripe
                </v-chip>
              </a>

            </div>

            <div class="mt-2" v-if="getCustomer.mohidId">
              <a style="text-decoration: none;"
                :href="`https://us.mohid.co/ny/newyork/muhammadimasjid/masjid/admin/donation/consolidation/${getCustomer.mohidId}`"
                target="_blank">
                <v-chip label color="brown darken-1" text-color="white">
                  <v-avatar left>
                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                  </v-avatar>
                  Mohid
                </v-chip>
              </a>

            </div>

            <div class="mt-2" v-if="getCustomer.payingCash">
              <v-chip label color="green" text-color="white">
                <v-avatar left>
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                </v-avatar>
                Cash
              </v-chip>
            </div>
          </v-flex>

          <v-spacer></v-spacer>
          <v-flex shrink>
            <div class="text-right">
              <v-tooltip bottom v-if="getCustomer.address">
                <template v-slot:activator="{ on }">
                  <a v-on="on" @click="openGoogleMap">
                    <div class="text-capitalize title">
                      {{ getCustomer.address }}
                    </div>
                    <div class="text-capitalize">
                      {{ getCustomer.city }}, {{ getCustomer.state }}
                      {{ getCustomer.zip }}
                    </div>
                  </a>
                </template>
                <span>Click to open google map</span>
              </v-tooltip>

              <div class="mt-1">
                <span class="font-weight-medium">Customer Since: </span>
                <span>{{ getCustomer.createdAt | moment("from", "now") }}</span>
              </div>

              <div class="mt-3">
                <div class="text-capitalize title">Balance</div>
                <div :style="{ color: balanceColor }" class="text-capitalize font-weight-light display-3">
                  {{ getCustomer.balance | currency }}
                </div>
                <div>Parent Pay: {{ studentFee.totalCustomerFee | currency }}</div>
                <div v-if="studentFee.totalCharity > 0">Masjid Pay: {{ studentFee.totalCharity | currency }}</div>
                <div v-if="studentFee.totalDiscount > 0">Total Discount: {{ studentFee.totalDiscount | currency }}</div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-tabs v-model="active" slider-color="primary" color="black" show-arrows grow>
      <v-tab>{{ $t("labels.dashboard") }}</v-tab>
      <!-- <v-tab>Statistics</v-tab> -->
      <!-- <v-tab>Order</v-tab> -->
      <v-tab>Students</v-tab>
      <!-- <v-tab>Subscriptions</v-tab> -->
      <!-- <v-tab>Payment Method</v-tab> -->
      <v-tab>All Invoice</v-tab>

      <v-tab>Payments</v-tab>
      <v-tab>Advance Payments</v-tab>
      <v-tab>Subscription</v-tab>
      <v-tab>Attachment</v-tab>
    </v-tabs>
    <v-tabs-items background-color="transparent" v-model="active" touchless="touchless">
      <v-tab-item>
        <Dashboard> </Dashboard>
      </v-tab-item>
      <!-- <v-tab-item>
        <Statistics> </Statistics>
      </v-tab-item> -->
      <!-- <v-tab-item>
        <OrderList v-if="getCustomer" :CustomerId="getCustomer.id"> </OrderList>
      </v-tab-item> -->
      <v-tab-item>
        <StudentList v-if="getCustomer" showBalance="hide" :CustomerId="getCustomer.id" />
        <!-- <InvoiceList
          :due="true"
          :showAll="true"
          v-if="getCustomer"
          :CustomerId="getCustomer.id"
        >
        </InvoiceList> -->
      </v-tab-item>
      <!-- <v-tab-item>
        <Subscriptions v-if="getCustomer" :Customer="getCustomer">
        </Subscriptions>
      </v-tab-item> -->
      <!-- <v-tab-item>
        <PaymentMethodList v-if="getCustomer" :CustomerId="getCustomer.id">
        </PaymentMethodList>
      </v-tab-item> -->
      <v-tab-item>
        <InvoiceList v-if="getCustomer" toggleStatus="hide" :internalUse="true"  :showAll="true" :CustomerId="getCustomer.id">
        </InvoiceList>
      </v-tab-item>
      <v-tab-item>
        <PaymentList v-if="getCustomer" :CustomerId="getCustomer.id">
        </PaymentList>
      </v-tab-item>
      <v-tab-item>
        <AdvancePaymentList v-if="getCustomer" :CustomerId="getCustomer.id">
        </AdvancePaymentList>
      </v-tab-item>
      <v-tab-item>
        <Subscription v-if="getCustomer" toggleStatus="hide"  :CustomerId="getCustomer.id">
        </Subscription>
      </v-tab-item>
      <v-tab-item>
        <AttachmentList v-if="getCustomer" TypeId="1" :RelationId="getCustomer.id">
        </AttachmentList>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
import customerService from "@/modules/Customer/service.js"
const Dashboard = () => import("@/modules/Customer/components/Dashboard.vue");
// const PaymentMethodList = () => import("@/modules/PaymentMethod/components/List.vue");
// const Subscriptions = () => import("@/modules/Stripe/components/List.vue");
const InvoiceList = () => import("@/modules/Invoice/components/List");
const StudentList = () => import("@/modules/Student/components/List");
const AttachmentList = () => import("@/modules/Attachment/components/List");
const AdvancePaymentList = () => import("@/modules/AdvancePayment/components/List");
// const OrderList = () => import("@/modules/Order/InHouse/components/List");
const PaymentList = () => import("@/modules/Invoice/Payment/components/List.vue");
// const DeleteCustomer = () => import("../components/DeleteCustomer");
const PaymentCollectLink = () => import("@/modules/Customer/components/PaymentCollectLink.vue");

const SyncBalance = () =>
  import("@/modules/Customer/components/syncBalance.vue");
const Statement = () => import("@/modules/Customer/components/Statement");
const ParentInvoiceCreate = () => import("@/modules/Customer/components/ParentInvoiceCreate.vue");
const Subscription = () => import("@/modules/Subscription/components/List.vue");

// const SearilSearch = () =>
//   import("@/modules/Customer/components/ImeiSearch.vue");

import { mapGetters, mapActions } from "vuex";

import Hashids from "hashids";
const hashids = new Hashids();

const Edit = () => import("@/modules/Customer/components/Edit");

export default {
  name: "customer-profile",
  data() {
    return {
      active: 0,
      customerCurrentIndex: 0,
      createParentInvoiceDialog: false,
      fab: false,
      editDialog: false,
      id: null,
      studentFee: {
        totalCustomerFee: 0,
        totalCharity: 0,
        totalDiscount: 0,
      },
    };
  },
  watch: {
    $route(to, from) {
      if (to && from && to.name === from.name) {
        this.loadData();
      }
    },
  },
  components: {
    Edit,
    // Subscriptions,
    StudentList,
    PaymentCollectLink,
    Subscription,
    SyncBalance,
    Dashboard,
    Statement,
    // PaymentMethodList,
    InvoiceList,
    AttachmentList,
    AdvancePaymentList,
    PaymentList,
    // OrderList,
    // DeleteCustomer,
    ParentInvoiceCreate,
    // Statistics,
    // SearilSearch,
  },
  async created() {
    await this.loadData();

    this.$events.listen("customerProfileEvent", () => {
      // this.$events.emit("invoiceListEvent");
      // this.$events.emit("paymentListEvent");
      // this.$events.emit("studentListEvent");
      // this.$events.emit("subscriptionListEvent");
      this.loadData();
      // if(this.$route.params.tab)
      //   this.active = this.$route.params.tab
      // else 
      // this.active = 0
    });
    this.getFeeAmount()
    this.setCurrentIndex()
    if(this.$route.params.tab)
      this.active = this.$route.params.tab
  },
  beforeDestroy() {
    this.$events.remove("customerProfileEvent");
  },
  computed: {
    ...mapGetters("customer", ["getCustomer", "customerList", "getActiveTab"]),
    ...mapGetters("global", ["checkRightStatus"]),
    balanceColor() {
      let color = "black";
      if (this.getCustomer.balance > this.getCustomer.balanceLimit) {
        color = "red";
      } else {
        color = "green";
      }

      return color;
    },
    // active: {
    //   get(){
    //     return this.getActiveTab
    //   },
    //   set(val){
    //     this.setActiveTab(val)
    //   }
    // }
  },
  methods: {
    ...mapActions("customer", ["setCustomer", "setActiveTab"]),
    ...mapActions("global", ["setPageTitle"]),
    // test() {
    //   console.log('test')

    // let config = {
    //   method: 'get',
    //   maxBodyLength: Infinity,
    //   url: 'https://api.mypayvault.com/api/v2/customers',
    //   headers: {
    //     'Authorization': 'Basic M1o2VzBvMkRGUTRmQks1NXd6eGllcExuRnNGZkJYbVg6NzUyOQ=='
    //   }
    // };

    // axios.request(config)
    //   .then((response) => {
    //     console.log(JSON.stringify(response.data));
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    // },  
    clearStripe() {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          customerService.update(this.getCustomer.id, {
            stripeId: null
          }).then((response) => {
            if (response.data) {
              this.getCustomerData();
            }
          });
        }
      });
    },
    back() {
      this.active = null
      this.$router.go(-1)
    },
    setCurrentIndex() {
      if (this.customerList.length !== 0) {
        let index = this.customerList.findIndex(x => x.id == this.id);
        this.customerCurrentIndex = parseInt(index)
      }
    },
    async moveBack(id) {
      if (this.customerList.length !== 0) {
        this.customerCurrentIndex = parseInt(this.customerCurrentIndex) - 1;
        this.id = this.customerList[this.customerCurrentIndex].id
        this.$router.push({ path: `/parents/${this.id}/profile` });
      } else {
        this.id = id + 1
        this.$router.push({ path: `/parents/${this.id}/profile` });
      }
      this.loadData()
      this.getFeeAmount()
      this.$events.emit("invoiceListEvent");
      this.$events.emit("paymentListEvent");
      this.$events.emit("studentListEvent");
      this.$events.emit("subscriptionListEvent");
    },
    async moveNext(id) {
      if (this.customerList.length !== 0) {
        this.customerCurrentIndex = parseInt(this.customerCurrentIndex) + 1;
        this.id = this.customerList[this.customerCurrentIndex].id
        this.$router.push({ path: `/parents/${this.id}/profile` });
      } else {
        this.id = id + 1
        this.$router.push({ path: `/parents/${this.id}/profile` });
      }
      // what to do ? 
      this.loadData()
      this.getFeeAmount()
      this.$events.emit("invoiceListEvent");
      this.$events.emit("paymentListEvent");
      this.$events.emit("studentListEvent");
      this.$events.emit("subscriptionListEvent");
    },
    invoiceCreated() {
      this.createParentInvoiceDialog = !this.createParentInvoiceDialog
      this.$events.emit("invoiceListEvent");
      this.getCustomerData()
    },
    viewOpenInvoice() {
      const hashId = hashids.encode(this.getCustomer.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/openInvoice`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    viewBalanceLetter() {
      const hashId = hashids.encode(this.getCustomer.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/PendingBalanceLetter`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    newInvoice() {
      this.$router.push({
        path: `/invoice/create?CustomerId=${this.getCustomer.id}`,
      });
    },
    async loadData() {
      await this.getCustomerData()
      await this.getFeeAmount()
    },
    getFeeAmount() {
      return customerService.getFeeByCustomerId(this.id).then((response) => {
        this.studentFee = response.data;
        // this.note = this.lead.note;
      });
    },
    async getCustomerData() {
      this.id = this.$route.params.id || this.getCustomer.id;


      this.$Progress.start();

      await this.setCustomer(this.id).then(() => {
        // console.log('result setCustomer', result)
        
      }).catch(err => {
        console.log('err', err)
      })
      // this.setPageTitle(this.getCustomer.name);
      console.log("getCustomer", this.getCustomer);
      this.$Progress.finish();
    },
    openGoogleMap() {
      window.open(
        `https://www.google.com/maps/place/${this.getCustomer.address} ${this.getCustomer.city},${this.getCustomer.state} ${this.getCustomer.zip}`,
        "_blank"
      );
    },
    sendEmail() {
      let routeData =
        "https://mail.google.com/mail/?view=cm&fs=1&to=" +
        this.getCustomer.email;
      window.open(routeData, "newwindow", "width=800, height=950");
    },
    closeEdit() {
      this.editDialog = false;
    },
    updated() {
      this.closeEdit();
      this.loadData();
    },
  },
};
</script>
